import { LoyaltyReferralCommissionItem } from "../../../../Redux/referral/types";
import { mapLoyaltyItemToRecord } from "../earningsAdapters";
import LoyaltyReferralTable from "./LoyaltyReferralTable";

interface Props {
  data: LoyaltyReferralCommissionItem[];
}

const SponsorCommTable = ({ data }: Props) => {
  return (
    <LoyaltyReferralTable
      rows={(data || []).map(mapLoyaltyItemToRecord)}
    />
  );
};

export default SponsorCommTable;
